import { PageHeader } from "@/components/v2/page-header";
import { TodaysJobsSection } from "@/components/v2/today/todays-jobs-section";
import { FollowUpsSection } from "@/components/v2/today/follow-ups-section";
import { RecentActivitySection } from "@/components/v2/today/recent-activity-section";
import { CommissionSnapshotSection } from "@/components/v2/today/commission-snapshot-section";
import { useCurrentUser } from "@/hooks/use-current-user";
import { useGreeting } from "@/hooks/use-greeting";
import { useRoleVariant } from "@/hooks/use-role-variant";
import { TODAY_SECTION_COPY } from "./copy";

// ADV-799: Today page (Phase 5 — role-variant copy applied).
//
// Section titles swap by role variant; data scope is already differentiated
// upstream at the API via CASL. Greeting is identical across variants.

export default function V2TodayPage() {
  const user = useCurrentUser();
  const greeting = useGreeting(user?.displayName);
  const variant = useRoleVariant();
  const copy = TODAY_SECTION_COPY[variant];

  return (
    <>
      <PageHeader breadcrumbs={[{ label: "Today" }]} title={greeting} />
      <TodaysJobsSection title={copy.jobs} />
      <FollowUpsSection title={copy.followUps} />
      <RecentActivitySection title={copy.activity} />
      <CommissionSnapshotSection title={copy.commission} />
    </>
  );
}
